
import { toast } from "sonner";

/**
 * Imports a journey map from a JSON file
 */
export const importJourneyMap = (
  setStages: (stages: any[]) => void,
  setJourney: (journey: any) => void
) => {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = '.json';
  
  input.onchange = (e: Event) => {
    const file = (e.target as HTMLInputElement).files?.[0];
    if (!file) return;
    
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const importedData = JSON.parse(event.target?.result as string);
        
        if (importedData.stages && Array.isArray(importedData.stages)) {
          setStages(importedData.stages);
        }
        
        if (importedData.journey) {
          setJourney(importedData.journey);
        }
        
        toast.success(`Journey map imported successfully`);
      } catch (error) {
        toast.error("Failed to parse file");
        console.error(error);
      }
    };
    reader.readAsText(file);
  };
  
  input.click();
};
